import { styled } from '@mui/material/styles';
import { Container as MuiContainer, Box as MuiBox } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

// Root container with vertical padding
export const Root = styled(MuiContainer)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));

// Wrapper for controls with bottom margin
export const ControlsWrapper = styled(MuiBox)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
}));

// Wrapper for the data grid to set height and full width
export const TableWrapper = styled(MuiBox)(() => ({
  height: 400,
  width: '100%',
}));

// Styled DataGrid to apply cell and header borders
export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-cell': {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}));

export const StatisticsTitle = styled('div')(({ theme }) => ({
  fontSize: '2.125rem', // h4 default
  fontWeight: 400,
  lineHeight: 1.235,
  letterSpacing: '0.00735em',
  marginBottom: theme.spacing(1),
  // Same responsive font sizes as TeamNameTitle
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem', // Smaller on mobile
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '1.75rem', // Medium on tablet
  },
  [theme.breakpoints.between('md', 'lg')]: {
    fontSize: '2rem', // Slightly smaller on medium screens
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '2.125rem', // Full h4 size on large screens
  },
}));

export const TeamNameTitle = styled('span')(({ theme }) => ({
  display: 'inline-block',
  verticalAlign: 'bottom',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  // Responsive font sizes to fit better
  fontSize: 'inherit', // Inherit from parent h4
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem', // Smaller on mobile
    maxWidth: '200px', // Conservative width on mobile
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '1.75rem', // Medium on tablet  
    maxWidth: '300px', // More space on tablet
  },
  [theme.breakpoints.between('md', 'lg')]: {
    fontSize: '2rem', // Slightly smaller on medium screens
    maxWidth: '400px', // Even more space
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '2.125rem', // Full h4 size on large screens
    maxWidth: '600px', // Maximum space on large screens
  },
}));
